export function ConvertArrayStringToNumber(data) {
    let numberArray = data.map((i) => Number(i));
    return numberArray;
}
